import { Component, Fragment, Prop, h } from '@stencil/core';

@Component({
  tag: 'input-checkbox-toggle',
  styleUrl: 'input-checkbox-toggle.css',
})
export class InputCheckboxToggle {
  @Prop() errorMessage: string = '';
  @Prop() hasError: boolean = false;
  @Prop() captionText: string = '';
  @Prop() isDisabled: boolean = false;
  @Prop() titleText: string = '';
  @Prop({ mutable: true }) isChecked: boolean = false;
  @Prop() isLocked: boolean = false;
  @Prop() whenChanged: (value: boolean) => void = () => {};

  onChange(value) {
    this.isChecked = value;
    this.whenChanged(value);
  }

  shouldDisplayError() {
    return this.hasError && this.errorMessage;
  }

  render() {
    const containerClass = {
      'input-checkbox-toggle': true,
      'input-checkbox-toggle--error': this.hasError,
    };

    const buttonClass = {
      group: true,
      'input-checkbox-toggle__button': true,

      'input-checkbox-toggle__button--checked': this.isChecked || this.isLocked,
      'input-checkbox-toggle__button--disabled': this.isDisabled,
      'input-checkbox-toggle__button--error': this.hasError,
    };

    const checkmarkBoxClass = {
      'input-checkbox-toggle__checkbox': true,
      'after:hidden': !this.isChecked,

      'input-checkbox-toggle__checkbox--checked': this.isChecked,
      'input-checkbox-toggle__checkbox--disabled': this.isDisabled,
      'input-checkbox-toggle__checkbox--checked-disabled': this.isChecked && this.isDisabled,
    };

    const overlayClass = {
      'transition ease-in-out duration-200 box-border absolute top-0 w-5 h-5 rounded-full': true,
      'group-hover:shadow-checkbox': !this.isDisabled && !this.isLocked,
    };

    return (
      <div class={containerClass}>
        <label class={buttonClass}>
          <input
            type="checkbox"
            name="checkboxToggle"
            checked={this.isChecked}
            onChange={() => this.onChange(!this.isChecked)}
            disabled={this.isDisabled || this.isLocked}
            class="absolute left-0 top-0 opacity-0"
          />
          <div class="mr-3 relative w-5">
            {this.isLocked ? (
              <icon-lock class="input-checkbox-toggle__lock-icon absolute w-5" />
            ) : (
              <Fragment>
                <div class={checkmarkBoxClass} data-testid="checkmark-box" />
                <div class={overlayClass} />
              </Fragment>
            )}
          </div>
          <div>
            {this.titleText && (
              <div class="text-sm font-normal leading-5 whitespace-normal break-words min-w-1 min-h-1" data-testid="title-text">
                {this.titleText}
              </div>
            )}
            {this.captionText && (
              <div class="mt-1 text-caption break-words" data-testid="caption-text">
                {this.captionText}
              </div>
            )}
          </div>
        </label>
        {this.shouldDisplayError() && <div class="text-xs pl-4">{this.errorMessage}</div>}
      </div>
    );
  }
}
